import { getLocalTimezone, findTimezone } from 'utils/timezones';
import { Shedule } from './consts';

export const getDefaultSchedule = () => ({
    time: Shedule.TIME,
    frequency: Shedule.FREQUENCY,
    timezone: findTimezone(getLocalTimezone(Shedule.TIMEZONE)),
    day_of_week: Shedule.DAY,
});

export function extendByDefaultSchedule(values) {
    return { ...values, schedule: getDefaultSchedule() };
}
